export const trackImpression = (eventType, entity, data) => {
  return {
    eventName: 'impression',
    ...data,
    trackingType: 'insights',
    entity,
    eventType,
  };
};

export const trackPageView = data => {
  return {
    eventName: 'pageView',
    ...data,
    trackingType: 'insights',
  };
};

export const trackInsightClicks = (eventType, entity, data) => {
  return {
    eventName: 'clicksOnLinks',
    ...data,
    trackingType: 'insights',
    entity,
    eventType,
  };
};
